// Collection Gallery Dot Pagination for Featured Collections
// Syncs dot navigation with the collection slider on mobile

function initializeCollectionDots() {
  const sliderComponents = document.querySelectorAll('slider-component');
  
  sliderComponents.forEach((sliderComponent) => {
    const dotsContainer = sliderComponent.querySelector('.collection-gallery-dots');
    if (!dotsContainer) return;

    // Éviter la réinitialisation multiple
    if (sliderComponent.dataset.dotsInitialized === 'true') return;
    sliderComponent.dataset.dotsInitialized = 'true';

    const dots = dotsContainer.querySelectorAll('.collection-gallery-dot');
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const slides = slider ? slider.querySelectorAll('.grid__item') : [];
    
    if (!slider || !dots.length || !slides.length) return;

    // Handle dot clicks - navigate to corresponding slide
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        const slideIndex = parseInt(this.getAttribute('data-slide-index'), 10);
        const targetSlide = slides[slideIndex];
        
        if (!targetSlide) return;

        // Update active states
        dots.forEach(d => d.classList.remove('is-active'));
        this.classList.add('is-active');

        // Scroll to the slide
        targetSlide.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest', 
          inline: 'start' 
        });

        // Update counter if it exists
        const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
        if (counterCurrent) {
          counterCurrent.textContent = index + 1;
        }
      });
    });

    // Listen for scroll events to update dots when user swipes
    slider.addEventListener('scroll', function() {
      const scrollLeft = slider.scrollLeft;
      const sliderWidth = slider.offsetWidth;
      
      let closestSlide = null;
      let closestIndex = 0;
      let minDistance = Infinity;
      
      slides.forEach((slide, idx) => {
        const slideLeft = slide.offsetLeft;
        const slideCenter = slideLeft + (slide.offsetWidth / 2);
        const viewportCenter = scrollLeft + (sliderWidth / 2);
        const distance = Math.abs(slideCenter - viewportCenter);
        
        if (distance < minDistance) {
          minDistance = distance;
          closestSlide = slide;
          closestIndex = idx;
        }
      });
      
      if (closestSlide) {
        // Update dots
        dots.forEach((dot, idx) => {
          if (idx === closestIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });

        // Update counter if it exists
        const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
        if (counterCurrent) {
          counterCurrent.textContent = closestIndex + 1;
        }
      }
    });

    // Listen for slider button clicks
    const prevButton = sliderComponent.querySelector('.slider-button--prev');
    const nextButton = sliderComponent.querySelector('.slider-button--next');
    
    if (prevButton) {
      prevButton.addEventListener('click', function() {
        updateDotsAfterButtonClick();
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function() {
        updateDotsAfterButtonClick();
      });
    }

    function updateDotsAfterButtonClick() {
      setTimeout(() => {
        const scrollLeft = slider.scrollLeft;
        const sliderWidth = slider.offsetWidth;
        
        let closestIndex = 0;
        let minDistance = Infinity;
        
        slides.forEach((slide, idx) => {
          const slideLeft = slide.offsetLeft;
          const slideCenter = slideLeft + (slide.offsetWidth / 2);
          const viewportCenter = scrollLeft + (sliderWidth / 2);
          const distance = Math.abs(slideCenter - viewportCenter);
          
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = idx;
          }
        });
        
        dots.forEach((dot, idx) => {
          if (idx === closestIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }, 50);
    }
  });
}

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', initializeCollectionDots);

// Réinitialiser après un changement de collection AJAX
document.addEventListener('collection:loaded', function() {
  // Retirer les flags d'initialisation
  document.querySelectorAll('slider-component[data-dots-initialized]').forEach(component => {
    component.dataset.dotsInitialized = 'false';
  });
  
  // Réinitialiser
  initializeCollectionDots();
});
